import { defineComponent as l, openBlock as r, createBlock as t, unref as a, mergeProps as i, withCtx as c, createElementVNode as p } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconEqualInCircleFilled",
  __name: "IconEqualInCircleFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (r(), t(a(m), i(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m-4 11a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8m0-4a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H8",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
